import { useParams } from 'react-router-dom';

import { ConnectedChargePointsTable } from 'features/charge-point/table';

export function ChargePointsGroupListPage() {
  const { groupId } = useParams() as { groupId: string };

  return <ConnectedChargePointsTable groupId={groupId} />;
}
